// Zustand der Echtzeit-Verbindung für die Oberfläche (Anzeige „Live“, Neuladen nach Wiederverbindung).
import { useEffect, useRef, useState } from "react";
import { echtzeit } from "../api/echtzeit";

type Zustand = "getrennt" | "verbindet" | "verbunden";

export function useVerbindung(): Zustand {
  const [z, setZ] = useState<Zustand>(echtzeit.zustand);
  useEffect(() => echtzeit.zustandAbonnieren(setZ), []);
  return z;
}

/** Ruft `cb` auf, wenn die Verbindung nach einem Abbruch wieder steht (dann Daten neu laden). */
export function useNeuVerbunden(cb: () => void): void {
  const ref = useRef(cb);
  ref.current = cb;
  useEffect(() => {
    let warVerbunden = echtzeit.zustand === "verbunden";
    let warWeg = false;
    return echtzeit.zustandAbonnieren((z) => {
      if (z === "verbunden") {
        if (warVerbunden && warWeg) ref.current();
        warVerbunden = true;
        warWeg = false;
      } else if (warVerbunden) {
        warWeg = true;
      }
    });
  }, []);
}
